<div [formGroup]="form">
  <!-- Input -->
  @if (tag === 'input') {
    <input
      class="bm--text-field"
      type="{{ type }}"
      placeholder="{{ title }}"
      formControlName="{{ controlFormName }}"
      [ngClass]="{
        'bm--text-field--error': form.get(controlFormName).invalid && form.get(controlFormName).touched,
        'bm--text-field--active': form.get(controlFormName).dirty,
        'theme-input__newsLetterBlock': themeInputClass === 'theme-input__newsLetterBlock',
        'theme-input__newsLetterBlock-placeholder':
          themeInputPlaceholderClass === 'theme-input__newsLetterBlock-placeholder',
        'theme-input__contactsBlock': themeInputClass === 'theme-input__contactsBlock',
        'theme-input__contactsBlock-placeholder':
          themeInputPlaceholderClass === 'theme-input__contactsBlock-placeholder',
        'theme-input__counterInput': themeInputClass === 'theme-input__counterInput',
        'theme-input__counterInput-placeholder': themeInputPlaceholderClass === 'theme-input__counterInput-placeholder'
      }"
    />
  }

  <!-- Textarea -->
  @if (tag === 'textarea') {
    <textarea
      class="bm--text-field bm--text-field--message"
      type="email"
      placeholder="{{ title }}"
      formControlName="{{ controlFormName }}"
      [ngClass]="{
        'bm--text-field--error': form.get(controlFormName).invalid && form.get(controlFormName).touched,
        'bm--text-field--active': form.get(controlFormName).dirty,
        'theme-input__contactsBlock': themeInputClass === 'theme-input__contactsBlock',
        'theme-input__contactsBlock-placeholder':
          themeInputPlaceholderClass === 'theme-input__contactsBlock-placeholder',
        'theme-input__counterInput': themeInputClass === 'theme-input__counterInput',
        'theme-input__counterInput-placeholder': themeInputPlaceholderClass === 'theme-input__counterInput-placeholder'
      }"
    >
    </textarea>
  }

  <!-- Errors -->
  @if (form.get(controlFormName).invalid && form.get(controlFormName).touched) {
    <div class="bm--common-error-message">
      <!-- Required field -->
      @if (form.get(controlFormName).errors['required']) {
        <p>
          {{
            controlFormName === 'passportAddressData'
              ? lg.forms.setEmptyErrorMessage(lang === 'ru' ? 'passport' : 'address')
              : lg.forms.setEmptyErrorMessage(controlFormName)
          }}
        </p>
      }
      <!-- Email pattern field -->
      @if (controlFormName === 'email' && form.get('email').errors['pattern']) {
        <p>
          {{ lg.forms.invalidEmail }}
        </p>
      }
      <!-- Phone pattern field -->
      @if (controlFormName === 'phone' && form.get('phone').errors['pattern']) {
        <p>Введите корректный номер телефона начиная с '+'. Пример: +79845654655</p>
      }
    </div>
  }
</div>
